import React, { useState } from 'react';
import CantonDropdown from './CantonDropdown';
import CategoryDropdown from './CategoryDropdown';
import CalendarRangePicker from './CalendarRangePicker';
import '../styles/EventFilters.css';

const EventFilters = ({ filters, onFilterChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (e) => {
    onFilterChange({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const handleReset = () => {
    onFilterChange({
      keyword: '',
      location: '',
      canton: '',
      eventType: '',
      startDate: getTodayDate(),
      endDate: ''
    });
  };

  return (
    <div className="event-filters">
      <button
        className="filter-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="4" y1="21" x2="4" y2="14"></line>
          <line x1="4" y1="10" x2="4" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12" y2="3"></line>
          <line x1="20" y1="21" x2="20" y2="16"></line>
          <line x1="20" y1="12" x2="20" y2="3"></line>
          <line x1="1" y1="14" x2="7" y2="14"></line>
          <line x1="9" y1="8" x2="15" y2="8"></line>
          <line x1="17" y1="16" x2="23" y2="16"></line>
        </svg>
        Filter {isExpanded ? 'ausblenden' : 'anzeigen'}
        <span className={`arrow ${isExpanded ? 'up' : 'down'}`}>▼</span>
      </button>

      <div className={`filters-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="filters-grid">
        <div className="filter-group">
          <label>Suche</label>
          <div className="search-input-wrapper">
            <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              name="keyword"
              placeholder="Events suchen..."
              value={filters.keyword}
              onChange={handleChange}
            />
          </div>
        </div>

<div className="filter-group">
          <label>Kanton</label>
          <CantonDropdown
            value={filters.canton}
            onChange={(val) => onFilterChange({ ...filters, canton: val })}
          />
        </div>

        <div className="filter-group">
          <label>Kategorie</label>
          <CategoryDropdown
            value={filters.eventType}
            onChange={(val) => onFilterChange({ ...filters, eventType: val })}
          />
        </div>

        <div className="filter-group">
          <label>Zeitraum</label>
          <CalendarRangePicker
            startDate={filters.startDate}
            endDate={filters.endDate}
            onRangeChange={({ startDate, endDate }) => onFilterChange({ ...filters, startDate, endDate })}
          />
        </div>
        </div>

        <button onClick={handleReset} className="btn-reset">Filter zurücksetzen</button>
      </div>
    </div>
  );
};

export default EventFilters;
